import React, { type ReactElement, memo } from 'react';
import { Button } from 'reactApp/ui/Button/Button';

import styles from './SelectAlbumPopupEmpty.css';

export interface SelectAlbumPopupEmptyProps {
    onCreateAlbum(): void;
    emptyTitle: string;
    emptyText: string;
    emptyBttnText: string;
}

export const SelectAlbumPopupEmpty = memo(function SelectAlbumPopupEmpty({
    onCreateAlbum,
    emptyTitle,
    emptyText,
    emptyBttnText,
}: SelectAlbumPopupEmptyProps): ReactElement {
    return (
        <div className={styles.empty} data-qa-id="select-album-empty">
            <div className={styles.folder} data-qa-id="folder" />
            <span className={styles.title} data-qa-id="title">
                {emptyTitle}
            </span>
            <span className={styles.text} data-qa-id="text">
                {emptyText}
            </span>

            <Button theme="vk" primary className={styles.button} onClick={onCreateAlbum}>
                {emptyBttnText}
            </Button>
        </div>
    );
});
